import { useQuery } from '@tanstack/react-query';
import { Content } from '../../interface/Content';
import { Paginated } from '@/interface/Paginate';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getLastContent = async () => {
  const api = setupApiClient();

  const authToken = getCookie(authKeys.authToken);
  const urlFetchLastContents = authToken
    ? apiConfig.routes.entertainment.content.lastViews
    : apiConfig.routes.entertainment.content.lastViewsPublic;

  const { data } = await api.get<Paginated<Content>>(urlFetchLastContents);
  return data.data;
};

export const useGetLastContent = () => {
  return useQuery({
    queryKey: ['last', 'content'],
    queryFn: getLastContent,
  });
};
